import { render, staticRenderFns } from "./EmailConfirmSuccess.vue?vue&type=template&id=15e67baf&"
import script from "./EmailConfirmSuccess.vue?vue&type=script&lang=ts&"
export * from "./EmailConfirmSuccess.vue?vue&type=script&lang=ts&"
import style0 from "./EmailConfirmSuccess.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports